(function () {
  const desktopQuery = window.matchMedia('(min-width: 993px)');
  const BRAND_OPEN_EVENT = 'sa:brand-mega-opening';
  const INDUSTRY_OPEN_EVENT = 'sa:industry-mega-opening';
  const SOLUTION_OPEN_EVENT = 'sa:solution-nav-opening';

  function closeMenu(container, trigger, keyboardClosed) {
    if (!container) return;
    container.classList.remove('is-open');
    container.classList.toggle('sa-industry-mega--keyboard-closed', keyboardClosed === true);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllIndustryMenus(exceptContainer, keyboardClosed) {
    document.querySelectorAll('[data-sa-industry-mega]').forEach((openContainer) => {
      if (openContainer === exceptContainer) return;
      const openTrigger = openContainer.querySelector('[data-sa-industry-mega-trigger]');
      closeMenu(openContainer, openTrigger, keyboardClosed);
    });
  }

  function openMenu(container, trigger) {
    document.dispatchEvent(new CustomEvent(INDUSTRY_OPEN_EVENT, { detail: { container } }));
    closeAllIndustryMenus(container, true);
    container.classList.remove('sa-industry-mega--keyboard-closed');
    container.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function toggleMenu(container, trigger) {
    if (container.classList.contains('is-open')) {
      closeMenu(container, trigger, true);
      return;
    }

    openMenu(container, trigger);
  }

  function initMenu(container) {
    if (container.dataset.saIndustryMegaReady === 'true') return;
    container.dataset.saIndustryMegaReady = 'true';

    const trigger = container.querySelector('[data-sa-industry-mega-trigger]');
    const menu = container.querySelector('[data-sa-industry-mega-menu]');
    if (!trigger || !menu) return;

    const closeButton = menu.querySelector('[data-sa-industry-mega-close]');
    const tabs = Array.from(menu.querySelectorAll('[data-sa-industry-menu-tab]'));
    const panels = Array.from(menu.querySelectorAll('[data-sa-industry-menu-panel]'));

    function activateIndustry(tab, focusTab) {
      if (!tab) return;

      const key = tab.dataset.saIndustryKey;
      tabs.forEach((item) => {
        const isActive = item === tab;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.saIndustryKey === key;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      if (focusTab) tab.focus();
    }

    if (tabs.length && panels.length) {
      activateIndustry(tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0], false);
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', () => {
        if (!desktopQuery.matches) return;
        activateIndustry(tab, false);
      });

      tab.addEventListener('focus', () => {
        if (!desktopQuery.matches) return;
        activateIndustry(tab, false);
      });

      tab.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        activateIndustry(tab, false);
      });

      tab.addEventListener('keydown', (event) => {
        if (!desktopQuery.matches) return;

        const nextKeys = ['ArrowDown', 'ArrowRight'];
        const previousKeys = ['ArrowUp', 'ArrowLeft'];
        let nextIndex = null;

        if (nextKeys.includes(event.key)) {
          nextIndex = (index + 1) % tabs.length;
        } else if (previousKeys.includes(event.key)) {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex !== null) {
          event.preventDefault();
          activateIndustry(tabs[nextIndex], true);
        }
      });
    });

    container.addEventListener('pointerenter', () => {
      if (!desktopQuery.matches) return;
      document.dispatchEvent(new CustomEvent(INDUSTRY_OPEN_EVENT, { detail: { container } }));
      closeAllIndustryMenus(container, true);
      container.classList.remove('sa-industry-mega--keyboard-closed');
      trigger.setAttribute('aria-expanded', 'true');
    });

    container.addEventListener('pointerleave', () => {
      if (!desktopQuery.matches) return;
      if (container.classList.contains('is-open')) return;
      trigger.setAttribute('aria-expanded', 'false');
    });

    container.addEventListener('focusin', () => {
      if (!desktopQuery.matches) return;
      if (container.classList.contains('sa-industry-mega--keyboard-closed')) return;
      document.dispatchEvent(new CustomEvent(INDUSTRY_OPEN_EVENT, { detail: { container } }));
      closeAllIndustryMenus(container, true);
      trigger.setAttribute('aria-expanded', 'true');
    });

    container.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (container.contains(document.activeElement)) return;
        container.classList.remove('sa-industry-mega--keyboard-closed');
        closeMenu(container, trigger);
      }, 0);
    });

    trigger.addEventListener('click', (event) => {
      if (!desktopQuery.matches) return;
      event.preventDefault();
      toggleMenu(container, trigger);
    });

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        closeMenu(container, trigger, true);
        trigger.focus();
      });
    }

    trigger.addEventListener('keydown', (event) => {
      if (!desktopQuery.matches) return;

      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openMenu(container, trigger);
        const firstItem = menu.querySelector('[data-sa-industry-menu-tab], a, button');
        if (firstItem) window.setTimeout(() => firstItem.focus(), 0);
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu(container, trigger, true);
      }
    });

    menu.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      closeMenu(container, trigger, true);
      trigger.focus();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sa-industry-mega]').forEach(initMenu);
    initTopMenuCloseGuards();
  }

  function initTopMenuCloseGuards() {
    document.querySelectorAll('.header__desktop .tiles-menu > li > a, .header__desktop .list-menu--inline > li > a').forEach((item) => {
      if (item.dataset.saIndustryCloseGuard === 'true') return;
      item.dataset.saIndustryCloseGuard = 'true';

      const container = item.closest('[data-sa-industry-mega]');
      if (container) return;

      const closeIndustryMenus = () => closeAllIndustryMenus(null, true);
      item.addEventListener('pointerenter', closeIndustryMenus);
      item.addEventListener('focus', closeIndustryMenus);
    });
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-sa-industry-mega].is-open').forEach((container) => {
      if (container.contains(event.target)) return;
      const trigger = container.querySelector('[data-sa-industry-mega-trigger]');
      if (trigger) closeMenu(container, trigger);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener(BRAND_OPEN_EVENT, () => closeAllIndustryMenus(null, true));
  document.addEventListener(SOLUTION_OPEN_EVENT, () => closeAllIndustryMenus(null, true));
})();
